import { useState } from "react";

const dropDownData = [
  {
    title: "network",
    text: "All Media",
  },
  {
    title: "image-s",
    text: "Image",
  },
  {
    title: "sound",
    text: "Sound",
  },
  {
    title: "text",
    text: "Text",
  },
  {
    title: "video",
    text: "Video",
  },
];

function GalleryHeader({ title }) {
  /*
   *To show/hide dropdown
   */
  const [showDropDown, setShowDropDown] = useState(false);

  /*
   *
   */
  const [dropdownImage, setDropDownImage] = useState("network");
  return (
    <div className="flex mb-2.5 flex-col sm:flex-row sm:items-center justify-between">
      <h1 className="font-semibold text-2xl	 ">{title}</h1>
      <div className="flex mt-4 items-center">
        <div className="rounded-full flex items-center border border-gray p-1 py-[10px]">
          <div
            className={`flex justify-between lg:justify-between	 cursor-pointer mx-2 relative items-center font-medium text-base block  ${
              showDropDown && "w-[220px]  rounded-full "
            }`}
            aria-current="page"
            onClick={() => {
              setShowDropDown(!showDropDown);
            }}
          >
            {
              /*
               *On dropDown  Show
               */
              showDropDown && (
                <p className="font-light	text-base mr-10	">Media Type</p>
              )
            }

            {!showDropDown ? (
              /*
               * Arrow Down
               */ <svg
                className=" w-8 h-4 mr-2 lg:ml-4"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                  clipRule="evenodd"
                ></path>
              </svg>
            ) : (
              /*
               * Arrow Up
               */
              <svg
                className=" w-8 h-4"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
                  clipRule="evenodd"
                ></path>
              </svg>
            )}
            <img src={`/${dropdownImage}.svg`} alt={dropdownImage} />
            {/*
             * Dropdown content
             */}
            <div
              id="dropdownNavbar"
              className={`absolute top-12 left-0 w-[220px]  bg-white px-2 z-10 lg:w-44b bg-white rounded border border-gray shadow ${
                !showDropDown && "hidden"
              } `}
            >
              <ul aria-labelledby="dropdownLargeButton">
                {dropDownData.map((dropDownItem, index) => (
                  <li
                    key={index}
                    onClick={() => setDropDownImage(dropDownItem.title)}
                    className="block border-b border-gray py-2 justify-between flex items-center"
                  >
                    {dropDownItem.text}{" "}
                    <img
                      src={`/${dropDownItem.title}.svg`}
                      alt={dropDownItem.title}
                    />
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className="flex border ml-2.5 w-full border-gray rounded-full p-1 lg:w-[441px] overflow-hidden">
          <input
            placeholder="Search for anything"
            className="outline-none font-light	text-base w-full text-[#747474]	pl-4"
          />
          <img
            className="bg-blue cursor-pointer rounded-full p-2.5"
            src="/search.svg"
            alt="search"
          />
        </div>
      </div>
      <div className="hidden lg:block"></div>
    </div>
  );
}

export default GalleryHeader;
